import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';

interface LandingCtaProps {
  onPrimaryAction: () => void;
}

export const LandingCta: React.FC<LandingCtaProps> = ({ onPrimaryAction }) => {
  const { t } = useTranslation();

  return (
    <section className="bg-white text-slate-950">
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-5 py-14 md:flex-row md:items-center md:justify-between md:px-8">
        <div className="max-w-2xl">
          <h2 className="text-3xl font-bold">{t('landing.cta.title')}</h2>
          <p className="mt-3 text-slate-600">{t('landing.cta.description')}</p>
        </div>
        <button
          onClick={onPrimaryAction}
          className="inline-flex items-center justify-center gap-2 rounded-lg bg-slate-950 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-slate-800"
        >
          {t('landing.cta.button')}
          <ArrowRight size={18} />
        </button>
      </div>
    </section>
  );
};
